// Spanish translations
const es = {
    // App Header
    appTitle: "CLIA Analytics",

    // Language selector
    language: "Idioma",
    english: "Inglés",
    spanish: "Español",

    // Sidebar Menu
    menu: {
        home: "Inicio",
        mediaMonitoring: "Monitoreo de Medios",
        priceMonitor: "Monitor de Precios",
        priceAlerts: "Alertas de Precios",
        opportunities: "Oportunidades Comerciales",
        chat: "Conversaciones",
        aiAssistant: "CLIA Agent",
        newChat: "Nueva consulta",
        reports: "Reportes",
        analytics: "Análisis",
        admin: "Admin",
        administration: "Panel de Administración",
        settings: "Configuración",
        help: "Ayuda",
        faq: "Preguntas Frecuentes",
        guide: "Consultas sugeridas",
        contact: "Contacto",
        terms: "Términos y Condiciones",
        logout: "Cerrar Sesión",
        moduleDisabled: "Este módulo no está disponible para tu cuenta",
        recentChats: "Chats Recientes",
        noChats: "No hay conversaciones",
        savedQueries: "Consultas Guardadas",
        noSavedQueries: "No hay consultas guardadas",
        customReports: "Reportes Personalizados",
        newReport: "Nuevo reporte",
        noReports: "Sin reportes aún",
        deleteReport: "¿Deseas eliminar este reporte?",
        dataDictionary: "Diccionario de Datos",
        uploadedFiles: "Archivos Subidos",
        uploadFile: "Subir Archivo",
        noFiles: "No hay archivos subidos",
        confirmDelete: "Confirmar eliminación",
        deleteConversation: "¿Deseas eliminar esta conversación?",
        deleteSavedQuery: "¿Deseas eliminar esta consulta guardada?",
        agentMemory: "Memoria del Agente",
        agentMemoryTitle: "Instrucciones Personalizadas",
        agentMemoryDescription: "Escribe instrucciones que el agente recordará en todas tus conversaciones. Por ejemplo: preferencias, contexto de tu negocio, formato de respuestas, etc.",
        agentMemoryPlaceholder: "Ejemplo:\n- Siempre responde en español\n- Trabajo en el sector farmacéutico\n- Prefiero ver precios en MXN\n- Mis principales competidores son: Walmart, Soriana, Chedraui",
        agentMemoryTip: "También puedes usar '/recuerda' en el chat para que el agente agregue información automáticamente.",
        goToAdmin: "Ir al Panel de Administración",
        interactiveGuide: "Guía Interactiva",
        editTitle: "Editar título",
        noDictionary: "No hay diccionario configurado",
        uploading: "Subiendo...",
        deleteFile: "Eliminar archivo",
        fileTooLarge: "El archivo es muy grande. Máximo 15MB",
        saveError: "Error al guardar",
        saveMemoryError: "Error al guardar la memoria",
        comingSoon: "Próximamente",
        badgeNew: "Nuevo",
        roleAdmin: "Administrador",
        roleUser: "Usuario",
        // Secciones del sidebar
        sectionSocial: "Social Media",
        sectionAdvertising: "Publicidad",
        sectionCommercial: "Comercial",
        sectionWebMedia: "Web y Medios",
        // Items del sidebar
        socialMonitoring: "Social Media Monitoreo",
        instagramOrganic: "Instagram Orgánico",
        facebookOrganic: "Facebook Orgánico",
        tiktokOrganic: "TikTok Orgánico",
        digitalCampaigns: "Campañas Digitales",
        campaignsApi: "Campañas (API)",
        tiktokCampaigns: "Campañas TikTok",
        sales: "Venta",
        benefits: "Beneficios Cantabria",
        andromedapp: "AndromedApp",
        webTraffic: "Tráfico Web",
        news: "Noticias",
        aiInsights: "AI Insights",
        integrations: "Integraciones",
        users: "Usuarios",
        organicSocial: "Redes Orgánicas"
    },

    // Homepage - Media Monitoring
    homepage: {
        title: "Monitoreo de Medios",
        subtitle: "Configura tus keywords para monitorear noticias relevantes",
        configureKeywords: "Configurar Keywords",
        update: "Actualizar",
        searching: "Buscando...",
        customize: "Personalizar",
        country: "País de las noticias",
        countryHint: "Cambia el país de búsqueda. Las noticias se recargarán automáticamente.",

        // Tabs
        tabNews: "Noticias",
        tabSaved: "Destacadas",
        savedTitle: "Noticias Destacadas",

        // TikTok
        tiktokTitle: "Posts de TikTok",
        tiktokRefresh: "Actualizar TikTok",
        tiktokSearching: "Buscando...",
        tiktokPendingTitle: "Buscando posts en TikTok…",
        tiktokPendingHint: "Esto puede tardar 3-8 minutos. Puedes navegar a otra pestaña mientras tanto.",
        tiktokStartedAt: "Iniciado el",
        tiktokLastFetched: "Última actualización:",
        tiktokEmpty: "Sin posts todavía. Presiona Actualizar para iniciar la búsqueda.",
        tiktokEmptyNoKeywords: "Agrega keywords primero — TikTok usa las mismas keywords de noticias.",
        savedTiktoksHeader: "TikToks destacados",
        tiktokSortLabel: "Ordenar por",
        tiktokSortViews: "Más vistos",
        tiktokSortRecent: "Más recientes",
        tiktokSortOldest: "Más antiguos",
        tiktokSortLikes: "Más likes",
        tiktokSortComments: "Más comentarios",
        // Texto relativo de edad de post
        agoPrefix: "Hace",
        monthAgo: "mes",
        monthsAgo: "meses",
        yearAgo: "año",
        yearsAgo: "años",

        // Modal de comentarios
        commentsTitle: "Comentarios",
        commentsClose: "Cerrar",
        commentsViewOnTiktok: "Ver en TikTok",
        commentsLoadButton: "Cargar comentarios",
        commentsConfirmCount: "Este post tiene {count} comentarios.",
        commentsCap: "Guardaremos hasta {cap} comentarios (top por likes).",
        commentsCapExceeded: "El post excede {cap}. Guardaremos solo los top {cap} por likes.",
        commentsPending: "Buscando comentarios... Puede tardar 3-8 minutos.",
        commentsRetry: "Reintentar",
        commentsErrorGeneric: "No se pudieron cargar los comentarios.",
        commentsErrorNetwork: "Error de red al cargar comentarios.",
        commentsEmpty: "Sin comentarios disponibles.",
        commentsLoadedMeta: "{count} comentarios cargados · {when}",
        commentsViewThread: "Ver {count} respuestas en TikTok",

        // Análisis de sentimientos
        sentimentTitle: "Análisis de sentimientos",
        sentimentCta: "Analizar sentimientos",
        sentimentAnalyzing: "Analizando...",
        sentimentReanalyze: "Re-analizar",
        sentimentThemes: "Temas principales",
        sentimentTopPositive: "Top positivo",
        sentimentTopNegative: "Top crítico",
        sentimentErrorGeneric: "No se pudo completar el análisis.",
        sentimentErrorNetwork: "Error de red al analizar comentarios.",

        // Keywords panel
        keywordsConfig: "Configuración de Keywords",
        keywordsConfigDesc: "Define las palabras clave para monitorear noticias",
        searchPlaceholder: "Escribe una keyword y presiona Enter...",
        useIndustryTemplate: "Usar plantilla por industria",
        activeKeywords: "Keywords Activas",
        resetDefault: "Por defecto",
        clearAll: "Limpiar",
        loadingKeywords: "Cargando keywords...",
        noKeywordsConfigured: "No hay keywords configuradas.",
        addKeywordsHint: "Agrega keywords manualmente o usa una plantilla.",
        lastSaved: "Último guardado:",
        saveConfig: "Guardar Configuración",
        saving: "Guardando...",
        keywordsLimitError: "No es posible agregar más de 20 keywords",
        keywordsLimitReached: "Límite de 20 keywords alcanzado",
        confirmRestoreDefaults: "¿Restaurar las keywords por defecto de la organización?",

        // Status bar
        news: "noticias",

        // News section
        relevantNews: "Noticias Relevantes",
        readArticle: "Leer artículo",
        noLink: "Sin enlace",
        priorityMedia: "Medio priorizado",
        tabPriority: "Revistas",
        priorityNewsTitle: "Revistas seleccionadas",
        today: "Hoy",
        yesterday: "Ayer",
        daysAgo: "días",

        // Loading & empty states
        searchingNews: "Buscando noticias...",
        analyzingKeywords: "Analizando {count} keywords",
        searchMayTake: "Esto puede tardar 30-45 segundos",
        noNewsFound: "No se encontraron noticias",
        tryOtherKeywords: "Intenta con otras keywords o actualiza más tarde",
        searchNews: "Buscar noticias",

        // Presets
        presetsPharmaceutical: "Farmacéutica",
        presetsRetail: "Retail",
        presetsTechnology: "Tecnología",
        presetsFinance: "Finanzas"
    },

    // Alerts Page - Price Monitor
    alerts: {
        title: "Monitor de Precios",
        subtitle: "Alertas de cambio de precio en competidores",
        update: "Actualizar",
        info: "Información",

        // Config panel
        minThreshold: "Umbral ± (%)",
        productsPerChain: "Productos por cadena",
        filterByUpcs: "Filtrar por UPCs",
        enabled: "Activado",
        disabled: "Desactivado",
        apply: "Aplicar",
        upcs: "UPCs",

        // Summary
        alerts: "alertas",
        changeGte: "cambio",
        upcFilterActive: "Filtro UPCs activo",
        filterChannels: "Filtrar canales",

        // Product card
        previous: "Anterior:",
        current: "Actual:",
        viewHistory: "Ver historial",
        viewInStore: "Ver en tienda",

        // History modal
        priceHistory: "Historial de Precios",
        priceEvolution: "Evolución del precio",
        lastRecords: "Últimos {count} registros",
        date: "Fecha",
        regularPrice: "Precio Regular",
        salePrice: "Precio Oferta",
        finalPrice: "Precio Final",
        currentPrice: "Precio actual",
        detectedChange: "Cambio detectado",

        // UPC Manager
        manageTrackedUpcs: "Gestionar UPCs Monitoreados",
        fileExists: "Archivo existe con {count} UPCs",
        noTrackingFile: "No hay UPCs configurados. Agrega UPCs para comenzar a monitorear.",
        currentUpcs: "UPCs actuales",
        clear: "Limpiar",
        more: "más",
        loadFromFile: "Cargar desde archivo",
        downloadTemplate: "Descargar plantilla CSV",
        uploadFile: "Subir archivo CSV",
        orEnterManually: "O ingresa manualmente",
        upcsHint: "UPCs separados por coma o uno por línea. Al guardar se actualizará el archivo en S3.",
        cancel: "Cancelar",
        replaceAll: "Reemplazar todo",
        addUpcs: "Agregar UPCs",
        save: "Guardar",
        upcsStorageInfo: "Los UPCs guardados se usarán para filtrar las alertas de precio. El umbral aplica como variación absoluta (± %).",

        // States
        analyzingPriceChanges: "Analizando cambios de precio...",
        noPriceAlerts: "No hay alertas de precio",
        noChangesDetected: "No se detectaron cambios de precio mayores al {threshold}%",
        noChangesInTracked: "No se detectaron cambios de precio en tus {count} UPCs monitoreados",
        retry: "Reintentar",
        noHistoryAvailable: "No hay historial de precios disponible",
        lastRecordedDate: "Fecha no disponible",
        noUpcsConfigured: "No hay UPCs configurados",
        viewAllProducts: "Ver todos los productos",
        filterOnlyMyUpcs: "Filtrar solo mis UPCs",
        clearAllUpcs: "Eliminar todos los UPCs",
        replaceAllUpcs: "Reemplazar todos los UPCs existentes",

        // Info modal
        howToUse: "Cómo usar el Monitor de Precios",
        overviewTitle: "Vista general",
        overviewDesc: "Muestra los productos con mayor cambio de precio por cadena, útil para detectar movimientos significativos en el mercado.",
        filterByUpcsTitle: "Filtrar por UPCs",
        filterByUpcsDesc: "Activa el toggle 'Filtrar por UPCs' para ver solo los productos que has configurado. Para agregar UPCs:",
        filterStep1: "Haz clic en el botón 'UPCs'",
        filterStep2: "Descarga la plantilla CSV o sube tu archivo",
        filterStep3: "Los UPCs se guardan en tu carpeta",
        understood: "Entendido",

        // Sorting options
        sortBy: "Ordenar por",
        sortHighest: "Mayor variación",
        sortLowest: "Menor variación",
        sortPositive: "Solo aumentos",
        sortNegative: "Solo bajas",

        // Show all tracked UPCs
        showAllTracked: "Ver todos",
        showOnlyWithChanges: "Mostrar solo UPCs con cambios de precio",
        showAllTrackedUpcs: "Mostrar todos los UPCs prioritarios (con o sin cambio)",
        onlyChanges: "Con cambios",

        // Channels
        selectChannels: "Seleccionar canales",
        all: "Todos",
        none: "Ninguno",

        // Email notifications
        emailNotifications: "Notificaciones por email",
        emailNotificationsEnable: "Activar notificaciones por correo",
        emailNotificationsDisable: "Desactivar notificaciones por correo"
    },

    // Chat
    chat: {
        title: "CLIA Agent",
        placeholder: "Pregunta sobre tus datos · Escribe @ para archivos · /recuerda para entrenar al agente",
        send: "Enviar",
        thinking: "Pensando...",
        error: "Ocurrió un error. Por favor intenta de nuevo.",
        newConversation: "Nueva conversación",
        clearChat: "Limpiar chat",
        exportChat: "Exportar chat",
        disclaimer: "Aunque analizo datos rápidamente, la decisión final es tuya. Mis sugerencias son solo orientativas, revisa cuidadosamente antes de actuar.",

        // Suggested questions
        loadingSuggestions: "Generando sugerencias...",
        suggestedQuestions: [
            "¿Cuáles son los productos con mayores ventas en unidades del último mes?",
            "¿Qué categorías tienen los mejores márgenes de ganancia?",
            "¿Cómo se comparan nuestros precios con los del mercado por categoría?"
        ],

        // Data table
        rows: "filas",
        columns: "columnas",
        export: "Exportar",
        visualize: "Visualización avanzada",
        chartModalTitle: "Visualización de datos",
        viewData: "Ver Datos",
        downloadExcel: "Descargar Excel",
        downloadCSV: "Descargar CSV",
        downloadPDF: "Descargar PDF",
        loadingData: "Cargando datos...",
        options: "Opciones",
        saving: "Guardando...",
        saveQuery: "Guardar consulta",
        saveToReport: "Guardar en reporte",
        saveToReportTitle: "Guardar respuesta en reporte",
        saveChartToReportTitle: "Guardar gráfica en reporte",
        createNewReportWithMessage: "Crear nuevo reporte con esta respuesta",
        createNewReportWithChart: "Crear nuevo reporte con esta gráfica",
        orAddToExisting: "o añadir a uno existente:",
        loadingReports: "Cargando reportes…",
        noReportsYet: "No tienes reportes. Crea uno nuevo arriba.",
        blocksCount: "bloques",
        savedInReport: "Guardado en",
        view: "Ver",
        chart: "Gráfica",
        download: "Descargar",
        generateChart: "Generar gráfica",
        downloadTableAsExcel: "Descargar tabla como Excel",

        // Chart
        chartType: "Tipo de gráfico",
        bars: "Barras",
        lines: "Líneas",
        pie: "Circular",
        doughnut: "Dona",
        dataConfig: "Configuración de datos",
        xAxis: "Eje X (Categoría)",
        yAxis: "Eje Y (Valor)",
        aggregation: "Agregación",
        sum: "Suma",
        average: "Promedio",
        count: "Conteo",
        max: "Máximo",
        min: "Mínimo",
        dataLimit: "Límite de datos",
        allData: "Todos",
        categories: "categorías",
        records: "registros"
    },

    // Admin
    admin: {
        title: "Panel de Administración",
        back: "Volver",
        users: "Usuarios",
        files: "Archivos",
        guide: "Guía",
        plan: "Mi Plan",
        terms: "Términos",
        faq: "FAQ",
        integrations: "Integraciones",
        plans: "Planes",

        // User manager
        usersTitle: "Usuarios de la Organización",
        configureMyMFA: "Configurar mi MFA",
        totalUsers: "Total Usuarios",
        active7Days: "Activos (7 días)",
        active30Days: "Activos (30 días)",
        administrators: "Administradores",
        searchUsers: "Buscar usuarios...",
        addUser: "Agregar Usuario",
        editUser: "Editar Usuario",
        deleteUser: "Eliminar Usuario",
        username: "Usuario",
        organization: "Organización",
        role: "Rol",
        lastAccess: "Último Acceso",
        pbiAccess: "Accesos PBI",
        messages: "Mensajes",
        registrationDate: "Registro",
        actions: "Acciones",
        loadingUsers: "Cargando usuarios...",
        noUsersInOrg: "No hay usuarios en esta organización",
        never: "Nunca",
        justNow: "Hace un momento",
        minutesAgo: "min",
        hoursAgo: "h",
        yesterday: "Ayer",
        daysAgo: "días",
        weeksAgo: "semanas",

        // Plan manager
        planTitle: "Plan y Uso Mensual",
        monthlyQueries: "Consultas del Mes (Organización)",
        used: "utilizado",
        remaining: "restantes",
        queries: "consultas",
        period: "Período",
        usersInOrg: "Usuarios",
        inOrg: "en la org.",
        planDetails: "Detalles del Plan",
        usersInOrganization: "Usuarios en la organización",
        monthlyLimit: "Límite mensual",
        queriesUsedThisMonth: "Consultas usadas este mes",
        planNote: "El contador muestra las consultas de TODOS los usuarios de la organización. Se reinicia automáticamente el primer día de cada mes.",
        orgExceededLimit: "La organización ha excedido el límite mensual",
        queriesLeft: "consultas para la organización",
        loadingPlan: "Cargando información del plan...",
        noUsageData: "No hay datos de uso disponibles",
        retry: "Reintentar",

        // File manager
        fileManagerTitle: "Gestor de Archivos",
        filesCount: "archivos",
        total: "total",
        searchFiles: "Buscar archivos...",
        uploadFile: "Subir Archivo",
        fileName: "Nombre del Archivo",
        fileType: "Tipo",
        size: "Tamaño",
        uploadedBy: "Subido Por",
        uploadDate: "Fecha de Carga",
        download: "Descargar",
        delete: "Eliminar",
        noPermission: "No tienes permisos para ver archivos",
        errorLoadingFiles: "Error al cargar archivos",
        fileTypeNotAllowed: "Tipo de archivo no permitido. Usa CSV, Excel, PDF o imágenes.",
        fileSizeExceeded: "El archivo excede el límite de 500 MB por archivo",
        uploading: "Subiendo...",
        fileUploadedSuccess: "Archivo subido correctamente",
        errorUploadingFile: "Error al subir archivo",
        connectionError: "Error de conexión al subir archivo",
        errorDownloading: "Error al generar enlace de descarga",
        errorDeleting: "Error al eliminar archivo",
        fileDeletedSuccess: "Archivo eliminado correctamente",
        dragDropHint: "Arrastra archivos aquí o haz clic para seleccionar",
        fileTypesHint: "CSV, Excel, PDF, Imágenes (máx 500MB por archivo)",
        loadingFiles: "Cargando archivos...",
        noFilesUploaded: "No hay archivos subidos",
        uploadFirstFile: "Sube tu primer archivo usando el área de arriba",
        file: "Archivo",
        type: "Tipo",
        uploaded: "Subido",
        confirmDelete: "Confirmar eliminación",
        confirmDeleteMessage: "¿Estás seguro de que deseas eliminar",
        cancel: "Cancelar"
    },

    // Interactive Guide
    guide: {
        title: "Guía Interactiva de Análisis",
        subtitle: "Explora los datos de pricing y elasticidad con consultas guiadas por rol o fase de análisis",
        byRole: "Por Rol",
        byPhase: "Por Fase",
        progress: "Progreso",
        completed: "completado",
        priority: "Prioridad",
        high: "Alta",
        medium: "Media",
        low: "Baja",
        estimatedTime: "Tiempo est.",
        minutes: "min",
        runQuery: "Ejecutar",
        running: "Ejecutando...",
        viewFullData: "Ver datos completos",
        loadingData: "Cargando datos...",
        processingQuery: "Procesando consulta...",
        close: "Cerrar",
        queriesCount: "consultas",

        // Roles
        roles: {
            ceo: "CEO",
            ceoDesc: "Visión estratégica global de pricing y su impacto en la rentabilidad",
            cfo: "CFO",
            cfoDesc: "Impacto financiero de las estrategias de pricing",
            commercial: "Director Comercial",
            commercialDesc: "Oportunidades de crecimiento y estrategias de venta",
            revenue: "Director de Revenue Management",
            revenueDesc: "Optimización de ingresos y gestión de precios dinámicos",
            marketing: "Director de Marketing",
            marketingDesc: "Efectividad de campañas y estrategias de posicionamiento",
            ecommerce: "Gerente de eCommerce",
            ecommerceDesc: "Performance de canal online y pricing digital",
            priceAnalyst: "Analista de Precios",
            priceAnalystDesc: "Análisis detallado de precios y posicionamiento competitivo",
            elasticityAnalyst: "Analista de Elasticidad",
            elasticityAnalystDesc: "Sensibilidad de precios y análisis de elasticidad de demanda"
        },

        // Phases
        phases: {
            exploration: "Exploración de Datos",
            explorationDesc: "Entender la estructura y distribución de los datos",
            descriptive: "Análisis Descriptivo Pricing",
            descriptiveDesc: "Estadísticas y métricas del pricing actual",
            advanced: "Analítica Avanzada",
            advancedDesc: "Análisis predictivo y modelado",
            geographic: "Análisis Geográfico",
            geographicDesc: "Distribución regional y estrategias de pricing local",
            optimization: "Optimización de Precios",
            optimizationDesc: "Recomendaciones y simulación de escenarios",
            export: "Exportación",
            exportDesc: "Generar reportes y exportaciones"
        }
    },

    // Reports
    reports: {
        title: "Reportes y Análisis",
        loading: "Cargando reporte...",
        noReports: "No hay reportes disponibles",
        selectReport: "Selecciona un reporte para visualizar",
        lastUpdate: "Última actualización",
        fullscreen: "Pantalla completa",
        refresh: "Actualizar",
        myFilters: "Mis Filtros",
        savedFilters: "Filtros Guardados",
        saveCurrentFilters: "Guardar Filtros Actuales",
        filterName: "Nombre del filtro",
        filterNamePlaceholder: "Ej: 'Q1 2024 - Región Norte'",
        filterDescription: "Descripción (opcional)",
        saving: "Guardando...",
        apply: "Aplicar",
        deleteFilter: "Eliminar filtro",
        noFilters: "No tienes filtros guardados aún.",
        noFiltersHint: "Ajusta los filtros del reporte y guárdalos arriba.",
        filterSaved: "Filtros guardados exitosamente",
        filterApplied: "Filtros aplicados",
        filterDeleted: "Filtro eliminado",
        filterError: "Error al guardar filtros",
        enterFilterName: "Ingresa un nombre para el filtro",
        resetFilters: "Resetear Filtros",
        exportPdf: "Export PDF",
        default: "Por defecto",
        savedOn: "Guardado"
    },

    // Common
    // Redes Orgánicas (/social-organic): Instagram + Facebook + TikTok en una pantalla
    organic: {
        paidNote: "Tus anuncios sumaron {n} visualizaciones más en este periodo. Aquí solo ves lo orgánico.",
        seeAds: "Ver anuncios",
        organicViews: "Visualizaciones orgánicas",
        organicViewsHint: "Veces que se vieron tus publicaciones, reels e historias, sin contar anuncios.",
        organicViewsFbHint: "Veces que se vio el contenido de tu página, sin contar anuncios.",
        organicInteractionsHint: "Me gusta, comentarios, guardados y compartidos en tu contenido, sin contar anuncios.",
        profileVisitsHintIg: "Veces que alguien entró a tu perfil. Puede incluir visitas que llegaron desde un anuncio.",
        netInPeriod: "{n} en el periodo",
        statSaves: "Guardados",
        statSavesHint: "Personas que guardaron una publicación para verla después: una señal fuerte de interés.",
        statWebClicks: "Clics a tu sitio web",
        dailyFollowers: "Nuevos seguidores por día",
        dailyFollowersNone: "Instagram solo comparte este dato de los últimos 30 días.",
        dailyFollowersPartial: "Instagram solo guarda los últimos 30 días.",
        newFollowersWord: "nuevos seguidores",
        monthlyFollowers: "Seguidores por mes",
        monthlyFollowersHint: "Cuentas que empezaron y dejaron de seguirte cada mes, según Meta. No depende del periodo elegido: siempre muestra los últimos 12 meses. El mes en curso aparece más claro porque aún no termina.",
        monthlyFollowersNet: "{n} netos en {months} meses",
        monthlyFollowersNone: "Meta todavía no tiene este dato para la cuenta.",
        monthlyFollowersError: "No se pudieron cargar los seguidores por mes. Intenta de nuevo más tarde.",
        followsWord: "Nuevos seguidores",
        unfollowsWord: "Dejaron de seguir",
        netWord: "Neto",
        monthInProgress: "mes en curso",
        formatsTitle: "Qué formato funciona mejor",
        formatsHint: "Resultados orgánicos por formato. Las personas alcanzadas se cuentan por formato: quien vio un reel y una historia cuenta en los dos.",
        formatReach: "{n} personas alcanzadas",
        fmtREEL: "Reels",
        fmtPOST: "Publicaciones",
        fmtCAROUSEL: "Carruseles",
        fmtSTORY: "Historias",
        genderF: "Mujeres",
        genderM: "Hombres",
        genderU: "Sin especificar",
        whereTitle: "Dónde están",
        cities: "Ciudades",
        storiesSub: "Historias publicadas en este periodo",
        storiesPublished: "Historias publicadas",
        storiesAvgReach: "Alcance promedio",
        storiesExitRate: "Salieron antes de terminar",
        storiesExitHint: "De las veces que alguien veía tus historias, cuántas las cerró en lugar de seguir viendo.",
        storiesNone: "No hay historias guardadas de este periodo.",
        storiesNoneHint: "Instagram solo comparte las historias mientras están activas (24 h). A partir de ahora se guardan todos los días.",
        updating: "Actualizando…",
        mentionsTitle: "Te mencionaron",
        mentionsSub: "Publicaciones recientes de otras cuentas que te etiquetaron",
        mentionsNone: "Nadie ha etiquetado a la cuenta recientemente.",
        mentionsError: "No pudimos cargar las menciones por ahora.",
        newFollowersPost: "Seguidores nuevos",
        avgWatchTime: "Tiempo promedio visto",
        videoTitle: "Tus videos",
        videoOrganicPlays: "Reproducciones orgánicas",
        video30s: "Vistos 30 s o más",
        video30sHint: "El {pct} de las reproducciones orgánicas llegó a 30 segundos.",
        reviewsTitle: "Lo que dicen de tu página",
        reviewsRecommend: "{pct}% te recomienda",
        reviewsCount: "{n} reseñas en total",
        reviewsNone: "Tu página todavía no tiene reseñas.",
        latestReviews: "Reseñas más recientes",
        viewers: "Personas",
        organicWord: "orgánico",
        title: "Redes Orgánicas",
        subtitle: "Cómo les va a tus cuentas oficiales, todo en un solo lugar.",
        refresh: "Actualizar",
        updatedJustNow: "Actualizado hace un momento",
        updatedMinutes: "Actualizado hace {n} min",
        period: "Periodo",
        last7: "Últimos 7 días",
        last30: "Últimos 30 días",
        last90: "Últimos 90 días",
        custom: "Personalizado",
        short7: "7 días",
        short30: "30 días",
        short90: "90 días",
        customShort: "Fechas",
        showing: "{from} – {to}",
        pickDates: "Elige fecha de inicio y de fin",
        from: "Desde",
        to: "Hasta",
        tabNotConnected: "Sin conectar",
        tabError: "No se pudo cargar",
        tabLoading: "Cargando…",
        followersShort: "{n} seguidores",
        notConnectedTitle: "{network} aún no está conectado",
        notConnectedBody: "Un administrador debe conectar esta cuenta para que sus números aparezcan aquí.",
        goToIntegrations: "Ir a Integraciones",
        errorTitle: "No pudimos cargar los números",
        errorBody: "Suele ser temporal. Intenta de nuevo en un momento.",
        retry: "Reintentar",
        demoNote: "Cuenta de demostración: estos números son de muestra.",
        partialData: "Algunos números no están disponibles por ahora; se muestran como —.",
        periodLast: "Últimos {n} días",
        periodCapped: "Últimos {n} días (lo máximo disponible)",
        periodRange: "{from} – {to}",
        today: "Hoy",
        followers: "Seguidores",
        followersHint: "Personas que siguen la cuenta hoy.",
        reach: "Alcance",
        reachHint: "Personas distintas que vieron tu contenido en el periodo.",
        views: "Visualizaciones",
        viewsHint: "Veces que se vio tu contenido en total. Una misma persona puede contar varias veces.",
        profileVisits: "Visitas al perfil",
        profileVisitsHint: "Veces que alguien entró a tu perfil.",
        pageVisits: "Visitas a la página",
        pageVisitsHint: "Veces que alguien entró a tu página de Facebook.",
        interactions: "Interacciones",
        interactionsHintFb: "Reacciones, comentarios, compartidos y clics en tus publicaciones.",
        interactionsHintTt: "Me gusta, comentarios y compartidos en tus videos.",
        videoViews: "Reproducciones de video",
        videoViewsHint: "Veces que se reprodujeron tus videos.",
        netFollowers: "Nuevos seguidores",
        netFollowersHint: "Seguidores que llegaron menos los que se fueron en el periodo.",
        gainedLost: "{gained} llegaron · {lost} se fueron",
        postsCount: "{n} publicaciones en total",
        videosCount: "{n} videos en total",
        peopleCount: "{n} personas",
        summaryTitle: "Resumen del periodo",
        statPosts: "Publicaciones en el periodo",
        statVideos: "Videos en el periodo",
        statAvg: "Interacciones promedio por publicación",
        statAvgVideo: "Interacciones promedio por video",
        statBestType: "El contenido que mejor funciona",
        statInterPerView: "Interacción por vista",
        engagement: "Engagement",
        engagementHint: "Interacciones promedio por publicación del periodo entre tus seguidores. Se calcula igual en Instagram, Facebook y TikTok, así que sirve para comparar redes y cuentas de distinto tamaño.",
        engagementSub: "Por publicación · {n} en el periodo",
        engagementSubVideos: "Por video · {n} en el periodo",
        engagementNone: "Sin publicaciones en el periodo",
        engagementNoneVideos: "Sin videos en el periodo",
        statEngagementTtHint: "Interacciones entre vistas de tus videos. Más alto = quien te ve responde más.",
        statShares: "Veces compartido",
        statVideoViews: "Vistas de estos videos",
        bestPost: "Publicación destacada del periodo",
        bestVideo: "Video destacado del periodo",
        nInteractions: "{n} interacciones",
        nViews: "{n} vistas",
        seeDetail: "Ver detalle",
        chartInterByPost: "Interacciones por publicación",
        chartInterByVideo: "Interacciones por video",
        byDate: "por fecha",
        chartTypeMix: "Qué contenido genera más interacción",
        chartTopPosts: "Mejores publicaciones",
        chartTopVideos: "Videos más vistos",
        chartReachByType: "Alcance por tipo de contenido",
        chartReachByTypeHint: "Cuántas personas ha alcanzado cada tipo de publicación desde que se publicó. Suma publicaciones, así que una misma persona puede contar más de una vez.",
        reachAccum: "alcance total",
        reachNone: "No hay datos de alcance para estas publicaciones.",
        fbDaily: "Actividad de la página por día",
        fbReactions: "Cómo reaccionó la gente",
        fbReactionsHint: "Todas las reacciones que recibió tu página en el periodo, incluso en publicaciones anteriores.",
        fbReactionsNone: "Sin reacciones en este periodo.",
        reactionsWord: "reacciones",
        interactionsWord: "interacciones",
        nPostsShort: "{n} publ.",
        nDays: "{n} días",
        likes: "Me gusta",
        comments: "Comentarios",
        shares: "Compartidos",
        clicks: "Clics",
        reactions: "Reacciones",
        visits: "Visitas",
        audienceTitle: "Tu audiencia",
        audienceSub: "Quién sigue tu cuenta de Instagram",
        gender: "Género",
        age: "Edad",
        ofFollowers: "% de seguidores",
        topCities: "Principales ciudades",
        countries: "Países",
        followerGrowth: "Crecimiento de seguidores",
        monthly: "por mes",
        stories: "Historias",
        storiesCount: "{n} historias",
        replies: "Respuestas",
        retention: "Retención",
        exits: "Salidas",
        reels: "Reels",
        reelsCount: "{n} reels",
        plays: "Reproducciones",
        avgWatch: "Tiempo promedio",
        saves: "Guardados",
        profileActions: "Acciones en tu perfil",
        website: "Sitio web",
        whatsapp: "WhatsApp",
        directions: "Cómo llegar",
        calls: "Llamadas",
        postsTitle: "Publicaciones",
        videosTitle: "Videos",
        gridView: "Cuadrícula",
        tableView: "Tabla",
        sortRecent: "Más recientes",
        sortTop: "Más interacciones",
        sortViews: "Más vistas",
        emptyPosts: "No hubo publicaciones en este periodo.",
        emptyVideos: "No hubo videos en este periodo.",
        emptyHint: "Prueba con un periodo más largo para ver más.",
        seeLast30: "Ver últimos 30 días",
        seeLast90: "Ver últimos 90 días",
        clearDayFilter: "Quitar filtro de día",
        noCaption: "Sin descripción",
        colPost: "Publicación",
        colVideo: "Video",
        colDate: "Fecha",
        colType: "Tipo",
        colInter: "Interacciones",
        colViews: "Vistas",
        typeImage: "Imagen",
        typeVideo: "Video",
        typeCarousel: "Carrusel",
        typeReel: "Reel",
        typePhoto: "Foto",
        typeAlbum: "Álbum",
        typeLink: "Enlace",
        typeEvent: "Evento",
        typeStatus: "Texto",
        typeOther: "Otro",
        rxLike: "Me gusta",
        rxLove: "Me encanta",
        rxCare: "Me importa",
        rxHaha: "Me divierte",
        rxWow: "Me asombra",
        rxSorry: "Me entristece",
        rxAnger: "Me enoja",
        rxThankful: "Agradecido",
        rxPride: "Orgullo",
        close: "Cerrar",
        viewOn: "Ver en {network}",
        commentsTitle: "Comentarios",
        loadComments: "Cargar comentarios",
        reloadComments: "Recargar",
        loadingComments: "Cargando…",
        noComments: "Esta publicación no tiene comentarios.",
        commentsError: "No se pudieron cargar los comentarios.",
        userFallback: "usuario"
    },

    common: {
        loading: "Cargando...",
        error: "Error",
        success: "Éxito",
        confirm: "Confirmar",
        cancel: "Cancelar",
        save: "Guardar",
        saving: "Guardando...",
        delete: "Eliminar",
        edit: "Editar",
        add: "Agregar",
        search: "Buscar",
        filter: "Filtrar",
        clear: "Limpiar",
        close: "Cerrar",
        back: "Atrás",
        next: "Siguiente",
        yes: "Sí",
        no: "No",
        ok: "OK",
        noData: "No hay datos disponibles",
        required: "Requerido",
        optional: "Opcional"
    },

    // User Profile
    profile: {
        title: "Perfil de Usuario",
        email: "Correo electrónico",
        organization: "Organización",
        role: "Rol",
        plan: "Plan",
        features: "Funcionalidades",
        logout: "Cerrar Sesión",
        settings: "Configuración"
    },

    // Floating Chat
    floatingChat: {
        title: "CLIA Agent",
        welcome: "¡Hola! Soy **CLIA**, tu asistente inteligente. Puedo ayudarte a consultar información del datalake, analizar precios de competencia y generar insights.\n\n**Funciones disponibles:**\n- Análisis de datos\n- Análisis de imágenes (gráficos, tablas, etc.)\n- Procesamiento de archivos Excel\n- Análisis de documentos PDF\n\n¿Qué te gustaría saber?",
        cleared: "Chat limpiado. Soy **CLIA**, tu asistente inteligente. ¿En qué puedo ayudarte?",
        save: "Guardar conversación",
        expand: "Expandir",
        restore: "Restaurar tamaño",
        clear: "Limpiar chat",
        minimize: "Minimizar",
        attach: "Adjuntar archivo",
        screenshot: "Capturar pantalla",
        analyzing: "Analizando...",
        // Screenshot guide
        screenshotGuideTitle: "Captura de Pantalla",
        screenshotGuideText: "Aparecerá un diálogo del navegador para seleccionar qué deseas compartir.",
        screenshotStep1: "Selecciona \"Esta pestaña\" en el diálogo",
        screenshotStep2: "Haz clic en \"Compartir\" para capturar",
        screenshotStep3: "Agrega tu pregunta y envía",
        cancel: "Cancelar",
        continueCapture: "Continuar"
    },

    // Errors
    errors: {
        generic: "Ocurrió un error. Por favor intenta de nuevo.",
        network: "Error de red. Verifica tu conexión.",
        unauthorized: "No autorizado. Por favor inicia sesión de nuevo.",
        notFound: "Recurso no encontrado.",
        serverError: "Error del servidor. Por favor intenta más tarde."
    },

    // Terms and Conditions
    tyc: {
        title: "Términos y Condiciones",
        sections: [
            {
                title: "1. Introducción",
                content: "Estos Términos y Condiciones rigen el uso del Balance Score Card Digital. Al utilizar este servicio, aceptas cumplir con todas las condiciones aquí descritas. Ten en cuenta que los precios sugeridos son solo una guía y deberán ser validados por el usuario final."
            },
            {
                title: "2. Uso del Servicio",
                content: "El asistente proporciona recomendaciones basadas en datos. Aunque se esfuerza por ser preciso, no garantizamos la exactitud absoluta de los resultados. Los precios sugeridos deben ser considerados como una guía y es responsabilidad del usuario final validarlos antes de su implementación."
            },
            {
                title: "3. Privacidad y Seguridad",
                content: "La privacidad y seguridad de tus datos se heredan de los SLA, reglas y políticas de seguridad de AWS y los servicios utilizados en la arquitectura del agente, como S3, Lambda, PostgreSQL y Bedrock. Además, los datos recopilados a través del asistente se utilizan exclusivamente para mejorar la precisión de las recomendaciones. No compartimos tus datos con terceros sin tu consentimiento explícito."
            },
            {
                title: "4. Limitaciones de Responsabilidad",
                content: "No seremos responsables por pérdidas o daños derivados del uso del asistente. El usuario final es responsable de validar los precios sugeridos antes de tomar decisiones comerciales."
            },
            {
                title: "5. Modificaciones",
                content: "Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones serán efectivas desde el momento de su publicación en esta página."
            },
            {
                title: "6. Contacto",
                content: "Para cualquier duda o aclaración sobre estos términos, puedes contactarnos a través de tu Asesor."
            }
        ]
    },

    // FAQ
    faq: {
        title: "Preguntas Frecuentes sobre Balance Score Card Digital",
        questions: [
            {
                question: "¿Qué es el Balance Score Card Digital?",
                answer: "Es una herramienta impulsada por inteligencia artificial que te ayuda a optimizar la estrategia de precios de tus productos, analizando ventas, márgenes, precios de la competencia y otros factores clave. Recuerda que los precios sugeridos son solo una guía y deben ser validados por el usuario final."
            },
            {
                question: "¿Qué tipo de datos se utilizan?",
                answer: "Utilizamos datos como la fecha de venta, identificadores de productos (SKU), unidades vendidas, precios finales, márgenes, y otros parámetros relacionados con la competencia y las ubicaciones geográficas."
            },
            {
                question: "¿Cómo se asegura la precisión de los precios recomendados?",
                answer: "El asistente utiliza modelos de machine learning que se entrenan constantemente con datos actualizados para ofrecer recomendaciones precisas y basadas en evidencia. Sin embargo, siempre debes validar las recomendaciones antes de implementarlas."
            },
            {
                question: "¿Cómo se protege la privacidad de mis datos?",
                answer: "La privacidad y seguridad de tus datos son nuestra prioridad. Estas se heredan de los SLA, reglas y políticas de seguridad de AWS y los servicios que utilizamos en la arquitectura del asistente, como S3, Lambda, PostgreSQL y Bedrock. Además, se manejan de acuerdo con las leyes y regulaciones vigentes, utilizando encriptación y otras medidas de seguridad avanzadas."
            },
            {
                question: "¿Puedo personalizar las recomendaciones de precios?",
                answer: "Sí, puedes ajustar los parámetros y criterios que utiliza el asistente para que las recomendaciones se adapten mejor a tus necesidades específicas. Aun así, los precios sugeridos deben ser validados antes de aplicarlos."
            }
        ]
    },

    // Guide Queries - Roles
    guideQueries: {
        roles: {
            ceo: {
                title: "CEO",
                description: "Visión estratégica global de pricing y su impacto en la rentabilidad",
                queries: [
                    { text: "Muéstrame un resumen ejecutivo con los KPIs de pricing más importantes y su impacto en la rentabilidad global", category: "resumen" },
                    { text: "¿Cuál es el impacto financiero de nuestras estrategias de pricing vs competencia?", category: "competencia" },
                    { text: "Análisis de tendencias de ventas por región y categoría en los últimos 6 meses", category: "tendencias" }
                ]
            },
            cfo: {
                title: "CFO",
                description: "Impacto financiero de las estrategias de pricing",
                queries: [
                    { text: "Impacto financiero de las estrategias de pricing optimizadas por IA", category: "financiero" },
                    { text: "Análisis de sensibilidad de precios y su efecto en el margen de contribución", category: "sensibilidad" },
                    { text: "Proyecciones financieras basadas en diferentes escenarios de pricing", category: "proyecciones" }
                ]
            },
            commercial: {
                title: "Director Comercial",
                description: "Oportunidades de crecimiento y estrategias de venta",
                queries: [
                    { text: "¿Cuáles son las principales oportunidades de crecimiento identificadas en los datos?", category: "oportunidades" },
                    { text: "Análisis de elasticidad de precios por segmento de cliente y canal de venta", category: "elasticidad" },
                    { text: "Recomendaciones de promociones cruzadas para maximizar el valor del cliente", category: "promociones" },
                    { text: "Rendimiento de ventas por canal y región con tendencias", category: "rendimiento" }
                ]
            },
            revenue: {
                title: "Director de Revenue Management",
                description: "Optimización de ingresos y gestión de precios dinámicos",
                queries: [
                    { text: "Dashboard de performance de pricing con alertas y recomendaciones", category: "dashboard" },
                    { text: "Análisis de la efectividad de las reglas de pricing implementadas", category: "efectividad" },
                    { text: "Simulación de escenarios de guerra de precios y estrategias de respuesta", category: "simulacion" }
                ]
            },
            marketing: {
                title: "Director de Marketing",
                description: "Efectividad de campañas y estrategias de posicionamiento",
                queries: [
                    { text: "Análisis de la efectividad de campañas de marketing en relación con las estrategias de pricing", category: "campañas" },
                    { text: "Recomendaciones de precios para nuevos lanzamientos de productos", category: "lanzamientos" },
                    { text: "Segmentación de clientes basada en sensibilidad al precio y comportamiento de compra", category: "segmentacion" }
                ]
            },
            ecommerce: {
                title: "Gerente de eCommerce",
                description: "Optimización del canal digital",
                queries: [
                    { text: "Optimización de precios en tiempo real para el canal online", category: "online" },
                    { text: "Análisis de comportamiento de compra en relación con los precios", category: "comportamiento" },
                    { text: "Estrategias de pricing personalizadas para diferentes segmentos de clientes online", category: "personalizacion" }
                ]
            },
            priceAnalyst: {
                title: "Analista de Precios",
                description: "Análisis detallado y modelado de precios",
                queries: [
                    { text: "Herramientas de modelado predictivo para análisis de escenarios de precios", category: "modelado" },
                    { text: "Reportes detallados de elasticidad de precios por SKU y categoría", category: "elasticidad" },
                    { text: "Alertas automáticas de anomalías en precios o comportamiento de compra", category: "anomalias" },
                    { text: "Dame una tabla con los top 20 productos por margen de contribución", category: "top_productos" }
                ]
            },
            categories: {
                title: "Director de Categorías",
                description: "Gestión de portfolio y optimización de categorías",
                queries: [
                    { text: "Análisis de contribución al margen por producto, categoría y cliente", category: "contribucion" },
                    { text: "Optimización de la estructura de descuentos y promociones", category: "descuentos" },
                    { text: "Identificación de oportunidades de mejora en la rentabilidad por categoría", category: "rentabilidad" }
                ]
            }
        },
        phases: {
            eda: {
                title: "Exploración de Datos (EDA)",
                description: "Análisis exploratorio inicial de los datos disponibles",
                queries: [
                    { text: "Dame una tabla con las principales tendencias de ventas por categoría", category: "tendencias" },
                    { text: "¿Cuáles son las columnas y métricas disponibles en los datos?", category: "estructura" },
                    { text: "Resumen estadístico de los datos de precios y ventas", category: "estadisticas" },
                    { text: "¿Qué período de tiempo cubren los datos disponibles?", category: "periodo" }
                ]
            },
            pricing: {
                title: "Análisis Descriptivo Pricing",
                description: "Análisis detallado de estrategias de precios actuales",
                queries: [
                    { text: "Distribución de precios por categoría y competidor", category: "distribucion" },
                    { text: "Análisis de gaps de precio vs competencia por categoría", category: "gaps" },
                    { text: "Evolución histórica de precios por producto y marca", category: "evolucion" },
                    { text: "Comparativa de márgenes por canal de venta", category: "margenes" }
                ]
            },
            elasticity: {
                title: "Analítica Avanzada de Elasticidad",
                description: "Análisis de sensibilidad de precios y elasticidad de demanda",
                queries: [
                    { text: "Cálculo de elasticidad precio-demanda por categoría", category: "elasticidad" },
                    { text: "Productos con mayor sensibilidad al precio", category: "sensibilidad" },
                    { text: "Impacto de cambios de precio en volumen de ventas", category: "impacto" },
                    { text: "Correlación entre precio y participación de mercado", category: "correlacion" }
                ]
            },
            geographic: {
                title: "Análisis Geográfico & Competitividad",
                description: "Análisis por región y posicionamiento competitivo",
                queries: [
                    { text: "Performance de ventas por región geográfica", category: "regional" },
                    { text: "Análisis de competitividad de precios por zona", category: "competitividad" },
                    { text: "Oportunidades de mercado por ubicación", category: "oportunidades" }
                ]
            },
            optimization: {
                title: "Optimización de Precios",
                description: "Recomendaciones de optimización basadas en análisis",
                queries: [
                    { text: "Recomendaciones de ajuste de precios para maximizar margen", category: "recomendaciones" },
                    { text: "Simulación de impacto de cambios de precio", category: "simulacion" },
                    { text: "Estrategia óptima de pricing por segmento", category: "estrategia" },
                    { text: "ROI esperado de las optimizaciones propuestas", category: "roi" }
                ]
            },
            export: {
                title: "Exportación de Recomendaciones",
                description: "Generación de reportes y exportación de datos",
                queries: [
                    { text: "Genera un reporte ejecutivo con las principales métricas", category: "reporte" },
                    { text: "Lista de productos con recomendación de cambio de precio", category: "lista" },
                    { text: "Resumen de hallazgos clave para presentación", category: "hallazgos" }
                ]
            }
        }
    },

    // MFA / TOTP setup
    mfa: {
        title: "Autenticación de dos factores (MFA)",
        loading: "Cargando configuración...",
        scanInstructions: "Escanea el código QR con tu app de autenticación (Google Authenticator, Authy, Microsoft Authenticator, 1Password, etc.).",
        cantScan: "¿No puedes escanear el QR?",
        manualSecret: "Ingresa este código manualmente en tu app de autenticación:",
        copy: "Copiar",
        copied: "Copiado",
        next: "Siguiente",
        back: "Atrás",
        cancel: "Cancelar",
        close: "Cerrar",
        retry: "Reintentar",
        enterCode: "Ingresa el código de 6 dígitos que aparece en tu app de autenticación:",
        verify: "Verificar",
        verifying: "Verificando...",
        processing: "Procesando...",
        successTitle: "¡MFA activado!",
        successDesc: "La próxima vez que inicies sesión te pediremos el código de 6 dígitos de tu app de autenticación.",
        nextLogin: "Necesitarás tu app de autenticación cada vez que inicies sesión.",
        alreadyEnabled: "MFA ya está activado en tu cuenta",
        alreadyEnabledDesc: "Estás usando una app de autenticación. Puedes reconfigurarlo (por ejemplo, al cambiar de dispositivo) o eliminarlo por completo.",
        reconfigure: "Reconfigurar MFA",
        remove: "Eliminar MFA",
        removeConfirmTitle: "¿Eliminar MFA?",
        removeConfirmDesc: "Tu cuenta dejará de tener autenticación de dos factores. Cualquier persona con tu contraseña podrá acceder. Esta acción se puede revertir activando MFA de nuevo.",
        confirmRemove: "Sí, eliminar",
        removedTitle: "MFA eliminado",
        removedDesc: "Ya no se te pedirá un código de autenticación al iniciar sesión. Te recomendamos volver a activarlo cuando puedas.",
        errorGeneric: "Ocurrió un error. Intenta de nuevo.",
        errorInvalidCode: "Código inválido. Verifica el código en tu app de autenticación e intenta de nuevo."
    },

    // Custom Reports (editor)
    report: {
        loading: "Cargando reporte…",
        titlePlaceholder: "Título del reporte",
        saving: "Guardando…",
        exportPdf: "PDF",
        exportPdfTitle: "Exportar a PDF (Imprimir → Guardar como PDF)",
        deleteReport: "Eliminar",
        deleteConfirm: "¿Eliminar este reporte? No se puede deshacer.",
        empty: "Este reporte está vacío.",
        emptyHint: "Agrega bloques desde la barra de abajo, o ve al chat y usa el botón \"Guardar en reporte\" en cualquier mensaje.",
        addBlockLabel: "+ Añadir bloque:",
        blockHeading: "Título",
        blockText: "Texto",
        blockDivider: "Separador",
        newHeading: "Nuevo título",
        newText: "Escribe aquí…",
        emptyPlaceholder: "*Vacío — click para editar*",
        botMessageLabel: "Respuesta del agente",
        clientMessageLabel: "Pregunta",
        moveUp: "Subir",
        moveDown: "Bajar",
        delete: "Eliminar",
        untitledHeading: "Sin título",
        markdownPlaceholder: "Escribe en markdown…",
        blockChartAlt: "Gráfica",
        chartCaptionPlaceholder: "Pie de gráfica (opcional)",
        placeholder: "Empieza a escribir, o usa los botones de arriba para insertar elementos…",
        savedJustNow: "Guardado",
        toolbar: {
            heading: "Estilo de texto",
            paragraph: "Párrafo",
            h1: "Título 1",
            h2: "Título 2",
            h3: "Título 3",
            insertTable: "Insertar tabla",
            deleteTable: "Eliminar tabla"
        }
    }
};

export default es;
